module.exports = __webpack_public_path__ + "img/PT2160.7c6344c1.png";